import React, { useRef, useMemo, useCallback, useState, useEffect} from 'react';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
//import { useNavigate } from 'react-router-dom';
import { getDefaultTheme, addToWatchList, removeFromList } from "../Utils/utils";
import { isTelegramWebApp } from '../Utils/utils';
import Modal from 'react-bootstrap/Modal';
import TokenDetails from './TokenDetailsPage';
import CallersList from './CallersListPage';


const ReactGrid = (props) => {
  //const [errorMessage, setErrorMessage] = useState('');
  //const navigate = useNavigate();
    const gridRef = useRef(); // Optional - for accessing Grid's API
    const [gridClassName, setGridClassName] = useState("");
    const [gridData, setGridData] = useState(props.rowData || []);
    const [show, setShow] = useState(false);
    const [modalParameterName, setModalParameterName] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [currentPageComponent, setCurrentPageComponent] = useState("tokenDetails");
  
    // DefaultColDef sets props common to all Columns
    const defaultColDef = useMemo( ()=> ({
        sortable: props.sortable
      }));
      
      const ModalDialog = (props) => {
        const handleClose = () => setShow(false);
        return (
          <Modal className='sgt-dialog' show={show} setFullscreen={true} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>{props.title || ""}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {currentPageComponent === "callersList" ? <CallersList name={modalParameterName} /> : 
                <TokenDetails nameOfCallGroup={modalParameterName} />
              }
              
            </Modal.Body>
          </Modal>
        )
      }

      const removeFromWatchList = (data) => {
        removeFromList(data);
      }
    // Example of consuming Grid Event
    const cellClickedListener = useCallback( e => {
      //console.log(e.column.colId);
      if(e.column.colId !== "BuyLink" && 
          props.onRowSelected && 
          props.gridName !== 'Top5CallersGrid' && 
          e.column.colId !== 'TokenName' &&
          e.column.colId !== 'FullTokenName' && 
          e.column.colId !== 'AddToWatchList' &&
          e.column.colId !== 'TokenHash' &&
          e.event.target.className.indexOf('btn') === -1
        ) { // the target is not a button
        const callGroup = e.data.NameOfCallGroup;
        //const positionOfCallGroup = e.data.PositionOfCallGroup;
        const paramName = encodeURIComponent(callGroup);
        const url = `/tokens/${paramName}`;
        if(isTelegramWebApp()) {
          // open in modal
          setShow(true);
          setModalParameterName(paramName);
          setModalTitle("Call Group Profile");
          setCurrentPageComponent("tokenDetails");
        }
        else {
          window.location.href = url;
        }
        
        // httpService.getSingleItem(callGroup).then((res) => {
        //   if(res) {
        //     //navigate(`/tokens/${callGroup}`, { state: {rowData: res, tokenName: e.data.TokenName, callGroup: callGroup, positionOfCallGroup: positionOfCallGroup, tokenData: e.data  } });
        //     window.location.href = `/tokens/${callGroup}`;
        //   }
        // })
        // .catch(err => {
        //   if(err) {
        //     console.log(err)
        //     //setErrorMessage(err);
        //   }
        // })
      }

      if(props.gridName && props.gridName === 'Top5CallersGrid') {
        if(isTelegramWebApp()) {
          // open in modal
          setShow(true);
          setModalParameterName(e.data.Name);
          setModalTitle("Call Group Profile");
          setCurrentPageComponent("tokenDetails");
        }
        else {
          window.location.href = `/tokens/${e.data.Name}`;
        }
      }
      if(e.column.colId === 'TokenName' || e.column.colId === 'FullTokenName' || e.column.colId === 'CallsFullTokenName' ) {
        if(isTelegramWebApp()) {
          // open in modal
          setShow(true);
          setModalParameterName(e.data.TokenHash);
          setModalTitle("Token Profile");
          setCurrentPageComponent("callersList");
        } 
        else {
          window.location.href = `/callers/${e.data.TokenHash}`;
        }
      }
      if(e.column.colId === 'AddToWatchList') {
        if(e.event.target.classList.value.indexOf('added') !== -1) {
          removeFromWatchList(e.data);
          e.event.target.classList.remove('added');
        }
        else {
          addToWatchList(e.data);
          e.event.target.classList.add('added');
        }
      }
      if(e.event.target.classList.value.indexOf('top-grid-name') !== -1) {
        const hash = e.data.TokenHash || e.event.target.innerText;
        const url = `/callers/${hash}`;
        if(isTelegramWebApp()) {
          // open in modal
          setShow(true);
          setModalParameterName(hash);
          setModalTitle("Token Profile");
          setCurrentPageComponent("callersList");
        } 
        else {
          window.location.href = url;
        }
      }
    }, []);

    // const onRowSelected = (e) => {
    //   if(props.onRowSelected) {
    //     console.log(e);
    //     const callGroup = e.data.NameOfCallGroup;
    //     const positionOfCallGroup = e.data.PositionOfCallGroup;
    //     httpService.getSingleItem(callGroup).then((res) => {
    //       if(res) {
    //         navigate(`/tokens/${callGroup}`, { state: {rowData: res, tokenName: e.data.TokenName, callGroup: callGroup, positionOfCallGroup: positionOfCallGroup, tokenData: e.data   } });
    //       }
    //     })
    //     .catch(err => {
    //       if(err) {
    //         console.log(err)
    //         //setErrorMessage(err);
    //       }
    //     })
    //   }
    // }

    const isFullWidthRow = useCallback((params) => {
      // in this example, we check the fullWidth attribute that we set
      // while creating the data. what check you do to decide if you
      // want a row full width is up to you, as long as you return a boolean
      // for this method.
      return params.rowNode.data ? params.rowNode.data.fullWidth : false;
    }, []);

    const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
    const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);

    const onSortChanged = (e) => {
      const api = (e && e.api) || (gridRef && gridRef.current && gridRef.current.api);

      // Prefer event.sortModel (fired before internal re-order) and fallback to api.getSortModel.
      let sortModel = Array.isArray(e && e.sortModel) ? e.sortModel : [];
      try {
        if ((!sortModel || sortModel.length === 0) && api && typeof api.getSortModel === 'function') {
          sortModel = api.getSortModel();
        }
      } catch (err) {
        sortModel = Array.isArray(e && e.sortModel) ? e.sortModel : [];
      }

      // forward sortModel to parent (parent sorts canonical data and re-supplies split rows)
      if (typeof props.onSortChanged === 'function') {
        props.onSortChanged(sortModel);
      } else if (typeof props.getRows === 'function' && api && typeof api.forEachNodeAfterFilterAndSort === 'function') {
        const rows = [];
        api.forEachNodeAfterFilterAndSort(node => rows.push(node.data));
        props.getRows(rows);
      }

      // clear AG Grid client sort after a short delay so parent's rowData replace can take effect
      if (api) {
        setTimeout(() => {
          try {
            if (typeof api.setSortModel === 'function') api.setSortModel([]);
            if (typeof api.refreshClientSideRowModel === 'function') api.refreshClientSideRowModel('filter');
            if (typeof api.refreshCells === 'function') api.refreshCells();
          } catch (err) {
            // non-fatal
          }
        }, 60);
      }
    }

    const onBodyScroll = (e) => {
      //console.log(e)
      if(e.direction === 'horizontal' && e.left > 0) {
        setGridClassName("scroll-horizontal-ag");
      }
      else {
        setGridClassName("");
      }
    }

    let rowHeight = window.innerWidth < 900 ? 69 : 69;
    if(isTelegramWebApp()) {
      rowHeight = 125;
    }
    const propsRowHeight = props.mobileRowHeight &&  window.innerWidth < 900 ? props.mobileRowHeight : props.rowHeight;

    useEffect(() => {
      setGridData(props.rowData || []); 
    }, [props.rowData])

    return (
      <div>
        <ModalDialog title={modalTitle} />
        <div style={containerStyle}>
            <div className={getDefaultTheme() === 'light' ? 'ag-theme-alpine' : 'ag-theme-alpine-dark'} style={gridStyle} >
              <AgGridReact
                ref={gridRef} // Ref for accessing Grid's API
                rowData={gridData} // Row Data for Rows
                columnDefs={props.columns} // Column Defs for Columns
                defaultColDef={props.defaultColDef || defaultColDef} // Default Column Properties
                getRowId={props.doubleRows ? params => {
                  if (!params || !params.data) return String((params && params.node && params.node.rowIndex) ?? 'row-0');
                  const d = params.data;
                  return String(d._gridId || d.ID || d.OriginalID || `${d.OriginalID || d._gridIdBase}-${d.isFirstHalf ? '1':'2'}` || (params.node && params.node.rowIndex) || 'row-0');
                } : undefined}
                getRowClass={props.doubleRows ? params => {
                  const idx = (params && params.node && typeof params.node.rowIndex === 'number')
                    ? params.node.rowIndex
                    : (typeof params.rowIndex === 'number' ? params.rowIndex : 0);
                  return (idx % 2 === 0) ? 'even-row' : 'odd-row';
                } : undefined}
                //maintainColumnOrder="true"
                //animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                rowSelection='single' // Options - allows click selection of rows
                //onRowSelected={onRowSelected}
                onCellClicked={props.cellClickedListener || cellClickedListener} // Optional - registering for Grid Event
                isFullWidthRow={props.isFullWidthRow || isFullWidthRow}
                embedFullWidthRows={true}
                tooltipShowDelay={0}
                tooltipInteraction={true}
                tooltipHideDelay={20000}
                rowHeight={propsRowHeight || rowHeight}
                onSortChanged={onSortChanged}
                suppressDragLeaveHidesColumns={true}
                // onBodyScroll={onBodyScroll}
                className={gridClassName}
                suppressScrollLag={true}
                suppressColumnVirtualisation={true}
                suppressRowHoverHighlight={true}
                enableCellTextSelection={false}
              />
            </div>
        </div>

        {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
        {/* <div style={containerStyle}>
          {props.errorMessage !== '' ? (
            <div className='error'>
              <h3>Something went wrong. Please try again.</h3>
            </div>
          ) : (
            <div className={getDefaultTheme() === 'light' ? 'ag-theme-alpine' : 'ag-theme-alpine-dark'} style={gridStyle} >
              <AgGridReact
                ref={gridRef}
                rowData={props.rowData}
                columnDefs={props.columns}
                defaultColDef={defaultColDef}
                maintainColumnOrder="true"
                animateRows={true}
                rowSelection='single'
                onCellClicked={cellClickedListener}
                isFullWidthRow={isFullWidthRow}
                embedFullWidthRows={true}
                tooltipShowDelay={0}
                tooltipInteraction={true}
                tooltipHideDelay={20000}
                rowHeight={65}
                onSortChanged={onSortChanged}
              />
            </div>
          )}
          
        </div> */}
      </div>
    );
}

export default ReactGrid;